import systemPsychotherapyQuestionSet from "../faq/systemPsychotherapy/allQuestions";

export const psychoterapySystem = {
    'meta': {
        'title': 'Psychoterapia systemowa #cityLocativeIn# • Centrum COLLIGO',
        'description': 'Terapia systemowa to jedna z najpopularniejszych i bardzo często stosowanych metod radzenia sobie z konfliktami w relacjach międzyludzkich.'
    },
    'availability': [
        'torun'
    ],
    'url': {
        'address': '#cityIdUrl#/uslugi/psychoterapia-systemowa/',
        'title': 'Psychoterapia systemowa #cityLocativeIn#',
        'name': 'Psychoterapia systemowa #cityLocativeIn#',
        'heading': 'Psychoterapia systemowa #cityLocativeIn#',
        'fullName': 'Psychoterapia systemowa'
    },
    'image': {
        'url': '/images/services/psychoterapia-systemowa-w-toruniu.webp',
        'width': 886,
        'height': 295,
        'alt': 'Psychoterapia systemowa #cityLocativeIn#'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/open-graph/psychoterapia-systemowa-w-toruniu.jpg',
            'width': 886,
            'height': 295,
            'alt': 'Psychoterapia systemowa #cityLocativeIn#'
        }
    },
    'faq': systemPsychotherapyQuestionSet
}